<template>
  <div>
    <hp-spinner :spinner="spinner" />
    <div class="row flex-row-reverse">
      <export-pdf
        :request="appRequest"
        isAllSolutions="tableCfg.isAllSolutions"
      ></export-pdf>
    </div>
    <div class="d-flex flex-column">
      <table-controls
        :data="tableCfg.filterUrl"
        :default-sort-field="tableCfg.defaultSortField"
        :default-ascending="ascending.value"
        :filtered-count="totalItems"
        :loading="spinner > 0"
        :show-filter="tableCfg.showFilter"
        :show-order="tableCfg.showOrder"
        @tableControlsChangeEvent="tableControlsChangeEvent"
      />
      <card-table
        v-show="showCardTable"
        :context="context"
        :table-data="tableData"
        :table-id="tableCfg.tableId"
        :class="{ 'is-loading': spinner > 0 }"
      />
      <div class="overlayContainer" v-if="showSearchResult">
        <div class="empty-search-result-icon"></div>
        <div class="subject">No results</div>
        <div class="text">
          Try selecting other filters or adjusting your search keyword.
        </div>
      </div>
      <table-footer-controls
        v-show="showFooter"
        :load-count="itemLimitPerPage"
        :total-items="totalItems"
        @pagingChangeHandler="pagingChangeHandler"
      />
    </div>
  </div>
</template>

<script>
import "../hpSpinner.scss";
import ExportPdf from "./ExportPdf.vue";
import HpSpinner from "./HpSpinner";
import TableControls from "./TableControls";
import TableFooterControls from "./TableFooterControls";
import CardTable from "./CardTable";
import TableDto, { Order, Paging } from "../js/TableDto.js";
import { API, Constants } from "../js/Constants.js";
import EventBus from "../EventBus.js";
import ApiSvc from "../js/ApiSvc";
import {
  REFRESH_TABLE_CONTROLS_EVENT,
  RESET_PAGING_EVENT,
} from "../js/event.js";

// const SEARCH_QUERY_ID = "query";
// const DASHBOARD_FILTER_TYPE = "STATUS";

export default {
  name: "catalog-data",
  components: {
    TableControls,
    TableFooterControls,
    CardTable,
    HpSpinner,
    ExportPdf,
  },
  props: {
    tableCfg: {
      columnList: Array,
      defaultSortField: String,
      filterUrl: Array,
      loadCount: { type: Number, default: 12 },
      showFilter: { type: Boolean, default: true },
      showOrder: { type: Boolean, default: false },
      tableId: { type: String, default: "" },
      url: Array,
    },
    ascending: {
      type: Object,
      default() {
        return { value: false };
      },
    },
    isAllSolutions: {
      type: Boolean,
    },
  },
  data() {
    return {
      context: {},
      itemLimitPerPage: 0,
      requestUrl: [],
      showCardTable: true,
      showEmptyData: false,
      showFooter: true,
      showSearchResult: false,
      spinner: 0,
      tableRequestData: new TableDto(),
      tableRequestAPI: new TableDto(),
      totalItems: 0,
      tableData: [],
      appRequest: {},
      flag: false,
    };
  },
  watch: {
    tableData() {
      const isDataNotEmpty = this.tableData.length !== 0;
      this.showFooter =
        this.itemLimitPerPage ===
        Constants.CARD_TABLE_DEFAULT_ITEM_NUMBER_PER_ROW
          ? false
          : isDataNotEmpty;
      this.showCardTable = isDataNotEmpty;
      this.showEmptyData =
        !isDataNotEmpty &&
        !this.tableRequestData.filter &&
        !this.tableRequestData.query;
    },
    ascending() {
      this.initRequestData();
      this.tableRequestData.resetPaging = true;
      this.loadTableData(this.requestUrl, this.tableRequestData);
    },
    tableCfg: {
      handler(newTableCfg) {
        this.requestUrl = newTableCfg.url;
        this.initRequestData();
        this.loadTableData(this.requestUrl, this.tableRequestData);
      },
      deep: true,
    },
  },
  created() {
    this.requestUrl = this.tableCfg.url;
    this.itemLimitPerPage = this.tableCfg.loadCount;
    this.initRequestData();
  },
  mounted() {
    EventBus.$emit(REFRESH_TABLE_CONTROLS_EVENT);
    this.tableRequestData.query = null;
    this.tableRequestData.filter = null;
    this.tableRequestData.resetPaging = true;
    this.tableRequestData.paging = new Paging(0, this.tableCfg.loadCount);
    this.tableRequestData.order = new Order(
      this.tableCfg.defaultSortField,
      false
    );
    this.loadTableData(this.requestUrl, this.tableRequestData);
  },

  methods: {
    initRequestData() {
      this.tableRequestData.paging = new Paging(0, this.itemLimitPerPage);
      this.tableRequestData.order = new Order(
        this.tableCfg.defaultSortField,
        this.ascending.value
      );
      console.log(this.tableRequestData.order);
    },
    tableControlsChangeEvent(data) {
      this.tableRequestData.query = data.query.length ? data.query : null;
      this.tableRequestData.filter = Object.keys(data.filter).length
        ? Object.assign({}, data.filter)
        : null;
      this.tableRequestData.order = data.order;
      this.tableRequestData.paging.limit = this.itemLimitPerPage;
      this.tableRequestData.paging.start = 0;
      this.tableRequestData.resetPaging = true;
      this.loadTableData(this.requestUrl, this.tableRequestData);
      this.tableRequestAPI = this.tableRequestData;
    },
    pagingChangeHandler(page) {
      this.tableRequestData.paging.start = (page - 1) * this.itemLimitPerPage;
      this.tableRequestData.resetPaging = false;
      this.loadTableData(this.requestUrl, this.tableRequestData);
      this.tableRequestAPI = this.tableRequestData;
    },
    loadTableData(url, requestData) {
      this.showSearchResult = false;
      this.spinner++;
      this.appRequest = requestData;
      if (this.$session.get("flag-value") == true) {
        this.tableRequestAPI = this.$session.get("raj-test");
        requestData.filter = this.tableRequestAPI.filter;
      } else {
        if (this.$session.exists("selectedFilterData")) {
          const data = new TableDto();
          const filtersMap = {};
          this.$session
            .get("selectedFilterData")
            .filter((item) => item.type !== "query")
            .forEach((item) => {
              if (Object.prototype.hasOwnProperty.call(filtersMap, item.type)) {
                filtersMap[item.type].push(item.id);
              } else {
                filtersMap[item.type] = [item.id];
              }
            });

          data.filter = filtersMap;

          this.tableRequestAPI = this.$session.get("raj-test");
          requestData.filter = this.tableRequestAPI.filter;
          requestData.filter = data.filter;
        }
      }
      this.$session.set("raj-test", requestData);
      console.log(this.$session.get("raj-test"));
      ApiSvc.request(["/appinfolist"], API.POST, requestData)
        .then((res) => res.data)
        .then((res) => {
          const { filteredSize } = res;
          const { resourceList } = res;
          this.totalItems = filteredSize;
          this.tableData = resourceList;
          this.context = { query: requestData.query };
          this.itemLimitPerPage = requestData.paging.limit; // change paging after loading
          if (requestData.resetPaging) {
            EventBus.$emit(RESET_PAGING_EVENT);
          }
          if (
            this.totalItems === 0 &&
            (this.tableRequestData.filter || this.tableRequestData.query)
          ) {
            this.showSearchResult = true;
          }
          this.spinner--;
        })
        .catch(() => this.spinner--);
    },
  },
};
</script>
<style scoped lang="scss">
@import "../styles/hpCustom.scss";
@import "../styles/hpConstant.scss";
@import "../styles/hpCommon.scss";
.is-loading {
  opacity: 0.35;
  pointer-events: none;
  transition: opacity 0.15s;
}

.overlayContainer {
  margin: 130px auto;

  .subject {
    color: $hpDeepGray;
    font-size: 21px;
    font-weight: $hpFontWeightMedium;
    line-height: 24px;
    text-align: center;
    margin-bottom: 5px;
  }

  .text {
    margin: 0 auto;
    color: $hpDeepGray;
    font-size: 16px;
    font-weight: 300;
    line-height: 22px;
    text-align: center;
  }
}
</style>
